import {NgModule} from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import {RouterModule} from '@angular/router';
import {MatDividerModule} from '@angular/material/divider';
import {MatIconModule} from '@angular/material/icon';
import {FuseFullscreenModule} from '@scientifica-cms-fe/components/fullscreen';
import {FuseNavigationModule} from '@scientifica-cms-fe/components/navigation';
import {LanguagesModule} from 'app/layout/common/languages/languages.module';


import {SearchModule} from 'app/layout/common/search/search.module';
import {UserModule} from 'app/layout/common/user/user.module';
import {SharedModule} from 'app/shared/shared.module';
import {ModernLayoutComponent} from 'app/layout/layouts/horizontal/modern/modern.component';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';

@NgModule({ declarations: [
        ModernLayoutComponent,
    ],
    exports: [
        ModernLayoutComponent
    ], imports: [RouterModule,
        MatButtonModule,
        MatDividerModule,
        MatIconModule,
        MatMenuModule,
        FuseFullscreenModule,
        FuseNavigationModule,
        LanguagesModule,
        // MatProgressBarModule,
        SearchModule,
        UserModule,
        SharedModule], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class ModernLayoutModule {
}
